/**
 * @description OTP Actions (enum)
 */
export enum OTPActionsEnum {
  /** 前台登入 */
  FrontendLogin = '1',
  /** 會員驗證 */
  MemberAuthentication = '2',
  /** 後台登入 */
  BackendLogin = '3',
  /** 非會員驗證 */
  NonMemberAuthentication = '4',
  /** 超過五年重新驗證身分 */
  Reauth = '5'
}
